export default [
  {
    title: "Overview",
    icon: "mdi-view-dashboard",
    route: "/overview",
  },
  {
    title: "Frames",
    icon: "mdi-file-upload-outline",
    route: "/frames",
  },
  {
    title: "Banners",
    icon: "mdi-file-upload-outline",
    route: "/banners",
  },
  {
    title: "Popup Image",
    icon: "mdi-file-upload-outline",
    route: "/popup-image",
  },
  {
    title: "Nettazy Daily",
    icon: "mdi-calendar-outline",
    route: "/nettazy-daily",
  },
  {
    title: "Templates",
    icon: "mdi-file-upload-outline",
    route: "/templates",
  },
  {
    title: "Customers",
    icon: "mdi-account-multiple",
    route: "/customers",
  },
  {
    title: "Promo Code",
    icon: "mdi-label",
    route: "/promo_code",
  },
  {
    title: "Political Party",
    icon: "mdi-gamepad-circle",
    route: "/political_party",
  },
  {
    title: "Transaction",
    icon: "mdi-wallet",
    route: "/transaction",
  },
  {
    title: "Contact Queries",
    icon: "mdi-account-box",
    route: "/contactform",
  },
  {
    title: "Notification",
    icon: "mdi-bell",
    route: "/notification",
  },
  
];
